import i18n from 'i18next';
import { Yup } from '../../../../services/common/validation';

const regexNumeric = /^[0-9]+$/;
const regexNumericSlash = /^[0-9/]+$/;
const regexName =
  /^[a-zA-ZÄÅáâäàãåÉéêëèíîïìÖóôöòõÜúüûùÇçÑñŠšß\\-\\.'][a-zA-ZÄÅáâäàãåÉéêëèíîïìÖóôöòõÜúüûùÇçÑñŠš ß\\-\\.']+$/;
export const DashBoardSubpageSchema = (subpage, offerReference = false) => {
  const offerId = Yup.string()
    .matches(regexNumericSlash, i18n.t('validation:invalidCharacter'))
    .max(120, i18n.t('validation:maxLength', { value: 120 }));
  const siren = Yup.string()
    .matches(regexNumeric, i18n.t('validation:invalidCharacter'))
    .min(14, i18n.t('validation:minLength', { value: 14 }))
    .max(120, i18n.t('validation:maxLength', { value: 120 }));
  const companyName = Yup.string()
    .matches(regexName, i18n.t('validation:invalidCharacter'))
    .min(2, i18n.t('validation:minLength', { value: 2 }))
    .max(120, i18n.t('validation:maxLength', { value: 120 }));
  const lastName = Yup.string()
    .matches(regexName, i18n.t('validation:invalidCharacter'))
    .min(2, i18n.t('validation:minLength', { value: 2 }))
    .max(120, i18n.t('validation:maxLength', { value: 120 }));
  const firstName = Yup.string()
    .matches(regexName, i18n.t('validation:invalidCharacter'))
    .min(2, i18n.t('validation:minLength', { value: 2 }))
    .max(120, i18n.t('validation:maxLength', { value: 120 }));
  const salesPerson = Yup.string()
    .min(2, i18n.t('validation:minLength', { value: 2 }))
    .max(120, i18n.t('validation:maxLength', { value: 120 }));
  const financialProduct = Yup.string()
    .min(2, i18n.t('validation:minLength', { value: 2 }))
    .max(120, i18n.t('validation:maxLength', { value: 120 }));
  const brand = Yup.string()
    .matches(regexName, i18n.t('validation:invalidCharacter'))
    .min(2, i18n.t('validation:minLength', { value: 2 }))
    .max(120, i18n.t('validation:maxLength', { value: 120 }));
  const statusId = Yup.string()
    .min(2, i18n.t('validation:minLength', { value: 2 }))
    .max(120, i18n.t('validation:maxLength', { value: 120 }));

  const commonForm = Yup.object().shape({
    siren,
    ...(offerReference ? { offerReference: offerId } : { offerId }),
    companyName,
    lastName,
    firstName,
    salesPerson,
    financialProduct,
    brand,
    statusId,
  });
  const runSchema = Yup.object().shape({
    siren,
    ...(offerReference ? { offerReference: offerId } : { offerId }),
    companyName,
    lastName,
    firstName,
    salesPerson,
    financialProduct,
  });
  if (subpage === 'run') {
    return runSchema;
  }
  return commonForm;
};
